import { PlaneGeometry } from "three";

export const simplePlaneGeometry = new PlaneGeometry(1, 1);
